import { useEffect } from 'react'
import NProgress from 'nprogress'
import { Box, CircularProgress, useTheme } from '@mui/material'

function SuspenseLoader() {
  const theme = useTheme()

  useEffect(() => {
    NProgress.start()

    return () => {
      NProgress.done()
    }
  }, [])

  return (
    <Box
      sx={{
        // This used to be `position: fixed; left: 0; width: 100%`, which centred
        // the spinner on the window — so on the console it landed a sidebar's
        // width too far left, near the rail's inner edge.
        //
        // Laying it out in the normal flow instead needs no knowledge of which
        // layout it is in: inside SidebarLayout it fills the content column,
        // which already sits beside the rail and below the header, and on the
        // signed-out screens it fills the page. The height is what the content
        // would have had, so it is the middle of the page either way.
        width: '100%',
        minHeight: `calc(100vh - ${theme.header.height})`,
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress size={64} disableShrink thickness={3} />
    </Box>
  )
}

export default SuspenseLoader
